import { useMemo, useState, type ReactNode } from "react";
import { useForm } from "react-hook-form";
import Header from "../../components/Header";
import Menu from "../../components/Menu";
import Form from "../../../../../components/shared/Form";
// import Table from "../../components/Table";
import Filters from "./Filters";
import Settings from "./Settings";
// import { useColumns } from "./columns";
import { useHomeFilters } from "../../../../TraxxionSchedule/Component/hooks/filters/useHomeFilters";
import { useCompanyPreferences } from "../../hooks/usePreferences";
import { usePreferenceMutation } from "../../api/usePreferenceMutation";
import { useGroups } from "../../../General/OrganisationLevelGroups/context";
import { buildDefaultFilters, flattenFilters } from "../../Timesheet/utils";

const options: string[] = [/** "columns", */ "filters", "settings"];

function My() {
    const [option, setOption] = useState("filters");
    // const columns = useColumns();
    const homeFilters = useHomeFilters();
    const { allocatedGroups } = useGroups();
    const mySchedule = useCompanyPreferences("mySchedule");
    const { mutate, isPending } = usePreferenceMutation("company", "mySchedule");

    // const defaultColumns = useMemo(() =>
    //     buildDefaultArray(columns, mySchedule?.columns ?? []),
    //     [columns, mySchedule]);

    const defaultFilters = useMemo(() =>
        buildDefaultFilters(flattenFilters(homeFilters), mySchedule?.filters ?? []),
        [homeFilters, mySchedule]);

    const formDefaults = useMemo(() => ({
        // columns: defaultColumns,
        filters: defaultFilters,
        defaultFilter: mySchedule?.defaultFilter ?? "",
        shiftCaseDisplay: mySchedule?.shiftCaseDisplay ?? "normal",
        colors: {
            regular: mySchedule?.colors?.regular ?? 0,
            approved: mySchedule?.colors?.approved ?? 0,
            submitted: mySchedule?.colors?.submitted ?? 0,
            locked: mySchedule?.colors?.locked ?? 0,
            unassigned: mySchedule?.colors?.unassigned ?? 0,
            openShift: mySchedule?.colors?.openShift ?? 0,
        },
        hideSummary: mySchedule?.hideSummary ?? false,
        hideDailyInfo: mySchedule?.hideDailyInfo ?? false,
        hideSort: mySchedule?.hideSort ?? false,
        hidePrint: mySchedule?.hidePrint ?? false,
        shiftDisplay: {
            job: mySchedule?.shiftDisplay?.job ?? true,
            payCode: mySchedule?.shiftDisplay?.payCode ?? true,
            ...Object.fromEntries((allocatedGroups ?? []).map((group: any) => {
                const key = group.level.replaceAll("_", "");
                return [key, mySchedule?.shiftDisplay?.[key] ?? true];
            })),
        },
        unavailableDisplay: mySchedule?.unavailableDisplay ?? "block",
    }), [defaultFilters, mySchedule, allocatedGroups]);

    const form = useForm({
        defaultValues: formDefaults,
        values: mySchedule === undefined ? undefined : formDefaults,
        resetOptions: { keepDirtyValues: true },
    });

    const onFinish = (value: typeof formDefaults) => mutate({ ...mySchedule, ...value });

    const panels: { key: string; node: ReactNode }[] = [
        { key: "filters", node: <Filters option="filters" /> },
        { key: "settings", node: <Settings /> },
    ];

    return (
        <div className="tw-p-5 tw-h-full tw-bg-white tw-rounded-lg">
            <Form className="tw-h-full" form={form} onFinish={onFinish}>
                <Header name="my-schedule" isLoading={isPending} />
                <Menu
                    options={options}
                    option={option}
                    setOption={setOption}
                />

                <div className="tw-px-7 tw-overflow-y-auto" style={{ height: `calc(100% - 100px)` }}>
                    {panels.map(({ key, node }) => (
                        <div
                            key={key}
                            className="tw-h-full"
                            style={{ display: option === key ? undefined : "none" }}
                        >
                            {node}
                        </div>
                    ))}
                </div>
            </Form>
        </div>
    );
}

export default My;
